import _ from 'lodash';
import promiseUtil from './promiseUtil';

export const videos = {
    video1: 'assets/scenario/scenario1.mp4',
    video2: 'assets/scenario/scenario2.mp4',
    video3: 'assets/scenario/scenario3.mp4',
    video4: 'assets/scenario/scenario4.mp4',
    video5: 'assets/scenario/scenario5.mp4',
    video6: 'assets/scenario/scenario6.mp4',
};

export const audios = {
    scenarioAppear: 'assets/audio/audio3.mp3',
    scenario: 'assets/audio/audio2.mp3',
    button: 'assets/audio/audio1.mp3',
    rightFact: 'assets/audio/audio5.mp3',
    wrongFact: 'assets/audio/audio4.mp3',
    transition: 'assets/audio/audio3.mp3',
    showMCQ: 'assets/audio/audio2.mp3',
    rightAnswer: 'assets/audio/audio6.mp3',
    wrongAnswer: 'assets/audio/audio4.mp3',
    finishScenario: 'assets/audio/audio2.mp3',
};

const fonts = [
    {url: 'assets/font/SofiaPro.otf', weight: 'normal'},
    {url: 'assets/font/SofiaProSemiBold.ttf', weight: 'bold'},
    {url: 'assets/font/SofiaProBold.otf', weight: '900'},
];

let loadResolve;
export const ready = new Promise(resolve => (loadResolve = resolve));

const videoURLs = {};
const audioBuffers = {};

window.AudioContext = window.AudioContext || window.webkitAudioContext;
const audioContext = new AudioContext();

loadAll().catch(console.error);

async function loadAll(medias, tagName) {
    await loadFonts();
    await loadVideos(videos);
    await loadAudios(audios);
    loadResolve();
}

async function loadFonts() {
    if (!('FontFace' in window)) {
        return;
    }

    for (const font of fonts) {
        const {url, weight} = font;
        const fontFace = new FontFace('SofiaPro', `url(${url})`);
        fontFace.weight = weight;
        await fontFace.load();
        document.fonts.add(fontFace);
    }
}

async function loadVideos(videos) {
    const videoResponses = await loadMedias(videos, 'blob');

    for (const {source, response} of videoResponses) {
        videoURLs[source] = URL.createObjectURL(response);
    }
}

async function loadMedias(medias, responseType) {
    const loadPromises = _.uniq(_.values(medias)).map(source =>
        loadMedia(source, responseType)
    );
    return await Promise.all(loadPromises);
}

function loadMedia(source, responseType) {
    return new Promise(resolve => {
        const request = new XMLHttpRequest();
        request.open('GET', source, true);
        request.responseType = responseType;

        request.onload = function() {
            resolve({
                source,
                response: this.response,
            });
        };

        request.send();
    });
}

async function loadAudios(audios) {
    const audioResponseList = await loadMedias(audios, 'arraybuffer');

    for (const {source, response} of audioResponseList) {
        const audioBuffer = await decodeAudioData(response);
        audioBuffers[source] = audioBuffer;
    }
}

function decodeAudioData(arrayBuffer) {
    const callback = promiseUtil.makeCallback();

    audioContext.decodeAudioData(
        arrayBuffer,
        audioBuffer => callback(null, audioBuffer),
        callback
    );

    return callback.promise;
}

export function resume() {
    audioContext.resume();
}

export function videoURL(source) {
    return videoURLs[source];
}

export async function playAudio(audioKey) {
    const source = audios[audioKey];
    const audioBuffer = audioBuffers[source];
    const bufferSourceNode = audioContext.createBufferSource();
    bufferSourceNode.buffer = audioBuffer;

    try {
        bufferSourceNode.connect(audioContext.destination);
        bufferSourceNode.start();
        await waitForEvents(bufferSourceNode, ['ended']);
    } finally {
        bufferSourceNode.disconnect();
    }
}

function waitForEvents(target, events) {
    return new Promise(resolve => {
        const listener = () => {
            resolve();

            for (const event of events) {
                target.removeEventListener(event, listener);
            }
        };

        for (const event of events) {
            target.addEventListener(event, listener);
        }
    });
}
